<script setup lang="ts">
import { STORYBLOK_ROUTES } from '#shared/constants/storyblok';

// COMPOSABLES
const { headerMenuItems } = await useStoryblokGlobalConfig();
const { trackLoginSignupButton } = useTracking();
const { openAuthModal } = useModals();
const { isLoggedIn } = useAuthUtils();
const { tt } = useTypedI18n();

// DATA
const isMobileMenuOpen = ref(false);

// METHODS
const toggleMobileMenu = (): void => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

const onLoginSignup = (): void => {
    trackLoginSignupButton();
    openAuthModal();
};
</script>

<template>
    <nav class="sticky inset-x-0 top-(--announcement-bar-height) z-40 flex w-full items-center justify-center bg-white ring-1 ring-neutral-300">
        <BaseWidthContainer as="header" class="relative z-40 flex h-(--header-height) flex-row flex-nowrap items-center justify-between gap-4">
            <div class="flex items-center gap-6">
                <NuxtLinkLocale :to="STORYBLOK_ROUTES.HOMEPAGE" @click="isMobileMenuOpen = false">
                    <SvgoFleequidLogo class="text-primary h-[26px]" :font-controlled="false" />
                </NuxtLinkLocale>

                <!-- Desktop/Tablet -->
                <UNavigationMenu
                    color="neutral"
                    arrow
                    content-orientation="vertical"
                    :items="headerMenuItems"
                    class="hidden w-full justify-center lg:flex"
                    :ui="{ content: 'w-auto' }"
                    :external-icon="false"
                />
            </div>

            <div class="flex items-center gap-3">
                <!-- Desktop/Tablet -->
                <LangSwitch class="hidden lg:block" />
                <HeaderAccountDropdownMenu v-if="isLoggedIn" class="hidden lg:block" />
                <UButton v-else :label="tt('common.loginSignup')" size="xl" class="hidden md:block" @click="onLoginSignup" />
                <!-- Mobile -->
                <div class="flex cursor-pointer items-center p-3 lg:hidden" @click="toggleMobileMenu">
                    <UIcon :name="isMobileMenuOpen ? 'lucide:x' : 'lucide:menu'" class="text-3xl" />
                </div>
            </div>
        </BaseWidthContainer>
    </nav>
    <MobileMenu v-model:open="isMobileMenuOpen" />
</template>
